






























































































import User from "@/models/user";
import { LayoutModule } from "@/store/layout";
import { UserModule } from "@/store/user";
import { Component, Vue, Emit, Prop } from "vue-property-decorator";

@Component
export default class UserForm extends Vue {
  @Prop({ default: "users.edit" }) title!: string;
  @Prop() initialUser?: User;
  @Prop({ default: false }) admin!: boolean;

  user: User = new User();
  loading = false;
  roles = ["admin", "seller"];

  get currentUser(): User {
    return UserModule.getCurrentUser;
  }

  get loaderIsVisible(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  created(): void {
    if (this.initialUser) this.user = new User(this.initialUser);
  }

  removeRole(role: string): void {
    this.user.role.splice(this.user.role.indexOf(role), 1);
    this.user.role = [...this.user.role];
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.save() : null;
  }

  @Emit()
  save(): User {
    return this.user;
  }
  @Emit()
  cancel(): null {
    return null;
  }
}
